import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      Challenge by
      <strong>
        <a
          href="https://www.frontendmentor.io/challenges/crowdfunding-product-page-7uvcZe7ZR"
          target="_blank"
          rel="noreferrer"
        >
          &nbsp;Frontend Mentor
        </a>
      </strong>
      . Developed by
      <strong>
        <a href="http://hasan-shaikh.com" target="_blank" rel="noreferrer">
          &nbsp;Hasan Shaikh
        </a>
      </strong>
      .
    </div>
  );
};

export default Footer;
